import React from 'react';
import StepForm from './StepForm';
import 'bootstrap/dist/css/bootstrap.min.css';

const AppB = ({countryName}) => {
  const selectedCountryValue = countryName;
  return (
    <div className='parent-div'>
      <StepForm countryName={selectedCountryValue} />
    </div>
  );
};

export default AppB;
